import type { SVGProps } from 'react';

export function IncognitoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.7 14.834c2.384 0 4.3 1.95 4.3 4.333S20.084 23.5 17.7 23.5c-2.31 0-4.18-1.83-4.295-4.111l-.005-.222-.006-.122a1.23 1.23 0 0 0-.35-.746 1.2 1.2 0 0 0-.844-.355 1.2 1.2 0 0 0-.844.355c-.227.228-.356.54-.356.868l-.006.222C10.88 21.67 9.01 23.499 6.7 23.5c-2.384 0-4.3-1.95-4.3-4.333s1.916-4.333 4.3-4.333a4.28 4.28 0 0 1 3.5 1.817 3.2 3.2 0 0 1 2-.707c.732 0 1.435.254 2 .708a4.28 4.28 0 0 1 3.5-1.818m-11 2c-1.26 0-2.3 1.035-2.3 2.333S5.44 21.5 6.7 21.5 9 20.465 9 19.167s-1.04-2.333-2.3-2.333m11 0c-1.26 0-2.3 1.035-2.3 2.333l.012.24c.119 1.183 1.106 2.093 2.288 2.093 1.26 0 2.3-1.035 2.3-2.333s-1.04-2.333-2.3-2.333M15.22 2.001a3.18 3.18 0 0 1 2.415 1.017c.27.289.483.625.63.99l.06.16.008.025 2.102 6.697H23a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h2.542l1.527-5.43a3.23 3.23 0 0 1 1.147-1.693A3.2 3.2 0 0 1 8.15 3.11H12c.177 0 .353-.04.514-.117v.001l1.403-.679a3.2 3.2 0 0 1 1.303-.315" />
    </svg>
  );
}
